// src/store/actions/productActions.js
import { PRODUCT_ACTIONS } from './actionTypes';
import productService from '../../services/productService';

// Fetch products
export const fetchProducts = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.FETCH_PRODUCTS_REQUEST });

    const response = await productService.getProducts(params);
    
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCTS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCTS_FAILURE,
      payload: error.message || 'Failed to fetch products',
    });
  }
};

// Fetch single product
export const fetchProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.FETCH_PRODUCT_REQUEST });

    const response = await productService.getProductById(id);
    
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCT_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCT_FAILURE,
      payload: error.message || 'Failed to fetch product',
    });
    throw error;
  }
};

// Create product
export const createProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.CREATE_PRODUCT_REQUEST });

    const response = await productService.createProduct(productData);
    
    dispatch({
      type: PRODUCT_ACTIONS.CREATE_PRODUCT_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.CREATE_PRODUCT_FAILURE,
      payload: error.message || 'Failed to create product',
    });
    throw error;
  }
};

// Update product
export const updateProduct = (id, productData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_PRODUCT_REQUEST });

    const response = await productService.updateProduct(id, productData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_PRODUCT_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_PRODUCT_FAILURE,
      payload: error.message || 'Failed to update product',
    });
    throw error;
  }
};

// Delete product
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_PRODUCT_REQUEST });

    const response = await productService.deleteProduct(id);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_PRODUCT_SUCCESS,
      payload: { id, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_PRODUCT_FAILURE,
      payload: error.message || 'Failed to delete product',
    });
    throw error;
  }
};

// Toggle product status
export const toggleProductStatus = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.TOGGLE_PRODUCT_STATUS_REQUEST });

    const response = await productService.toggleProductStatus(id);
    
    dispatch({
      type: PRODUCT_ACTIONS.TOGGLE_PRODUCT_STATUS_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.TOGGLE_PRODUCT_STATUS_FAILURE,
      payload: error.message || 'Failed to toggle product status',
    });
    throw error;
  }
};

// Product Features
export const addFeature = (productId, featureData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_FEATURE_REQUEST });

    const response = await productService.addFeature(productId, featureData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_FEATURE_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_FEATURE_FAILURE,
      payload: error.message || 'Failed to add feature',
    });
    throw error;
  }
};

export const updateFeature = (productId, featureId, featureData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_FEATURE_REQUEST });

    const response = await productService.updateFeature(productId, featureId, featureData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_FEATURE_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_FEATURE_FAILURE,
      payload: error.message || 'Failed to update feature',
    });
    throw error;
  }
};

export const deleteFeature = (productId, featureId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_FEATURE_REQUEST });

    const response = await productService.deleteFeature(productId, featureId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_FEATURE_SUCCESS,
      payload: { featureId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_FEATURE_FAILURE,
      payload: error.message || 'Failed to delete feature',
    });
    throw error;
  }
};

// Product Benefits
export const addBenefit = (productId, benefitData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_BENEFIT_REQUEST });

    const response = await productService.addBenefit(productId, benefitData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_BENEFIT_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_BENEFIT_FAILURE,
      payload: error.message || 'Failed to add benefit',
    });
    throw error;
  }
};

export const updateBenefit = (productId, benefitId, benefitData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_BENEFIT_REQUEST });

    const response = await productService.updateBenefit(productId, benefitId, benefitData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_BENEFIT_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_BENEFIT_FAILURE,
      payload: error.message || 'Failed to update benefit',
    });
    throw error;
  }
};

export const deleteBenefit = (productId, benefitId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_BENEFIT_REQUEST });

    const response = await productService.deleteBenefit(productId, benefitId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_BENEFIT_SUCCESS,
      payload: { benefitId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_BENEFIT_FAILURE,
      payload: error.message || 'Failed to delete benefit',
    });
    throw error;
  }
};

// Product Sections
export const addSection = (productId, sectionData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_SECTION_REQUEST });

    const response = await productService.addSection(productId, sectionData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_SECTION_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_SECTION_FAILURE,
      payload: error.message || 'Failed to add section',
    });
    throw error;
  }
};

export const updateSection = (productId, sectionId, sectionData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_SECTION_REQUEST });

    const response = await productService.updateSection(productId, sectionId, sectionData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_SECTION_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_SECTION_FAILURE,
      payload: error.message || 'Failed to update section',
    });
    throw error;
  }
};

export const deleteSection = (productId, sectionId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_SECTION_REQUEST });

    const response = await productService.deleteSection(productId, sectionId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_SECTION_SUCCESS,
      payload: { sectionId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_SECTION_FAILURE,
      payload: error.message || 'Failed to delete section',
    });
    throw error;
  }
};

// Product Q&A
export const addQA = (productId, qaData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_QA_REQUEST });

    const response = await productService.addQA(productId, qaData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_QA_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_QA_FAILURE,
      payload: error.message || 'Failed to add Q&A',
    });
    throw error;
  }
};

export const updateQA = (productId, qaId, qaData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_QA_REQUEST });

    const response = await productService.updateQA(productId, qaId, qaData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_QA_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_QA_FAILURE,
      payload: error.message || 'Failed to update Q&A',
    });
    throw error;
  }
};

export const deleteQA = (productId, qaId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_QA_REQUEST });

    const response = await productService.deleteQA(productId, qaId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_QA_SUCCESS,
      payload: { qaId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_QA_FAILURE,
      payload: error.message || 'Failed to delete Q&A',
    });
    throw error;
  }
};

// Pricing Tiers
export const addPricingTier = (productId, tierData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_PRICING_TIER_REQUEST });

    const response = await productService.addPricingTier(productId, tierData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_PRICING_TIER_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_PRICING_TIER_FAILURE,
      payload: error.message || 'Failed to add pricing tier',
    });
    throw error;
  }
};

export const updatePricingTier = (productId, tierId, tierData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_PRICING_TIER_REQUEST });

    const response = await productService.updatePricingTier(productId, tierId, tierData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_PRICING_TIER_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_PRICING_TIER_FAILURE,
      payload: error.message || 'Failed to update pricing tier',
    });
    throw error;
  }
};

export const deletePricingTier = (productId, tierId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_PRICING_TIER_REQUEST });

    const response = await productService.deletePricingTier(productId, tierId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_PRICING_TIER_SUCCESS,
      payload: { tierId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_PRICING_TIER_FAILURE,
      payload: error.message || 'Failed to delete pricing tier',
    });
    throw error;
  }
};

// Eligibility Criteria
export const addEligibility = (productId, eligibilityData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_ELIGIBILITY_REQUEST });

    const response = await productService.addEligibility(productId, eligibilityData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_ELIGIBILITY_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_ELIGIBILITY_FAILURE,
      payload: error.message || 'Failed to add eligibility criterion',
    });
    throw error;
  }
};

export const updateEligibility = (productId, eligibilityId, eligibilityData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_ELIGIBILITY_REQUEST });

    const response = await productService.updateEligibility(productId, eligibilityId, eligibilityData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_ELIGIBILITY_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_ELIGIBILITY_FAILURE,
      payload: error.message || 'Failed to update eligibility criterion',
    });
    throw error;
  }
};

export const deleteEligibility = (productId, eligibilityId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_ELIGIBILITY_REQUEST });

    const response = await productService.deleteEligibility(productId, eligibilityId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_ELIGIBILITY_SUCCESS,
      payload: { eligibilityId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_ELIGIBILITY_FAILURE,
      payload: error.message || 'Failed to delete eligibility criterion',
    });
    throw error;
  }
};

// Exclusions
export const addExclusion = (productId, exclusionData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.ADD_EXCLUSION_REQUEST });

    const response = await productService.addExclusion(productId, exclusionData);
    
    dispatch({
      type: PRODUCT_ACTIONS.ADD_EXCLUSION_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.ADD_EXCLUSION_FAILURE,
      payload: error.message || 'Failed to add exclusion',
    });
    throw error;
  }
};

export const updateExclusion = (productId, exclusionId, exclusionData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.UPDATE_EXCLUSION_REQUEST });

    const response = await productService.updateExclusion(productId, exclusionId, exclusionData);
    
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_EXCLUSION_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.UPDATE_EXCLUSION_FAILURE,
      payload: error.message || 'Failed to update exclusion',
    });
    throw error;
  }
};

export const deleteExclusion = (productId, exclusionId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_EXCLUSION_REQUEST });

    const response = await productService.deleteExclusion(productId, exclusionId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_EXCLUSION_SUCCESS,
      payload: { exclusionId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_EXCLUSION_FAILURE,
      payload: error.message || 'Failed to delete exclusion',
    });
    throw error;
  }
};

// Product Documents
export const fetchProductDocuments = (productId, params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.FETCH_PRODUCT_DOCUMENTS_REQUEST });

    const response = await productService.getProductDocuments(productId, params);
    
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCT_DOCUMENTS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCT_DOCUMENTS_FAILURE,
      payload: error.message || 'Failed to fetch documents',
    });
  }
};

export const requestPresignedUpload = (productId, fileData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.REQUEST_PRESIGNED_UPLOAD_REQUEST });

    const response = await productService.requestPresignedUpload(productId, fileData);
    
    dispatch({
      type: PRODUCT_ACTIONS.REQUEST_PRESIGNED_UPLOAD_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.REQUEST_PRESIGNED_UPLOAD_FAILURE,
      payload: error.message || 'Failed to request upload URL',
    });
    throw error;
  }
};

export const confirmDocumentUpload = (productId, uploadData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.CONFIRM_DOCUMENT_UPLOAD_REQUEST });

    const response = await productService.confirmDocumentUpload(productId, uploadData);
    
    dispatch({
      type: PRODUCT_ACTIONS.CONFIRM_DOCUMENT_UPLOAD_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.CONFIRM_DOCUMENT_UPLOAD_FAILURE,
      payload: error.message || 'Failed to confirm upload',
    });
    throw error;
  }
};

export const deleteProductDocument = (productId, documentId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.DELETE_PRODUCT_DOCUMENT_REQUEST });

    const response = await productService.deleteDocument(productId, documentId);
    
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_PRODUCT_DOCUMENT_SUCCESS,
      payload: { documentId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.DELETE_PRODUCT_DOCUMENT_FAILURE,
      payload: error.message || 'Failed to delete document',
    });
    throw error;
  }
};

// Fetch entities
export const fetchEntities = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.FETCH_ENTITIES_REQUEST });

    const response = await productService.getEntities(params);
    
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_ENTITIES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_ENTITIES_FAILURE,
      payload: error.message || 'Failed to fetch entities',
    });
  }
};

// Bulk delete
export const bulkDeleteProducts = (ids) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.BULK_DELETE_PRODUCTS_REQUEST });

    const response = await productService.bulkDeleteProducts(ids);
    
    dispatch({
      type: PRODUCT_ACTIONS.BULK_DELETE_PRODUCTS_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.BULK_DELETE_PRODUCTS_FAILURE,
      payload: error.message || 'Failed to bulk delete products',
    });
    throw error;
  }
};

// Get product statistics
export const fetchProductStats = () => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_ACTIONS.FETCH_PRODUCT_STATS_REQUEST });

    const response = await productService.getProductStats();
    
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCT_STATS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_ACTIONS.FETCH_PRODUCT_STATS_FAILURE,
      payload: error.message || 'Failed to fetch product stats',
    });
  }
};

// Set product filters
export const setProductFilters = (filters) => ({
  type: PRODUCT_ACTIONS.SET_PRODUCT_FILTERS,
  payload: filters,
});

// Clear error
export const clearProductError = () => ({
  type: PRODUCT_ACTIONS.CLEAR_PRODUCT_ERROR,
});

// Clear success
export const clearProductSuccess = () => ({
  type: PRODUCT_ACTIONS.CLEAR_PRODUCT_SUCCESS,
});

// Clear selected product
export const clearSelectedProduct = () => ({
  type: PRODUCT_ACTIONS.CLEAR_SELECTED_PRODUCT,
});